import { CustomCardColorBar, CustomPanel, PageHeader, PontuacaoCard } from '../../../../components'
import React from 'react'
import { azul, error, laranja } from '../../../../assets/js/colors'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'

function EtapaResumoSeparacao({ history }) {
  const etapaResumoSeparacaoInfo = history.location.state.etapa_resumo_separacao_info

  const { pontuacao_total, pontuacao_obtida, tp_name, resumo_info } = etapaResumoSeparacaoInfo

  // Helpers
  const getQtePickingCriados = () => {
    return resumo_info.length > 0
      ? resumo_info.reduce((total, item) => total + item.qte_picking_criados, 0)
      : '-'
  }

  const getQteResumoAtrasado = () => {
    return resumo_info.length > 0
      ? resumo_info.reduce((total, item) => {
          if (item.lista_resumo_atrasados.length > 0) {
            return total + item.lista_resumo_atrasados.split(',').length
          }
          return total
        }, 0)
      : '-'
  }

  const getQteResumoNaoEmitido = () => {
    return resumo_info.length > 0
      ? resumo_info.reduce((total, item) => {
          if (item.lista_resumo_nao_emitido.length > 0) {
            return total + item.lista_resumo_nao_emitido.split(',').length
          }
          return total
        }, 0)
      : '-'
  }

  // Render
  return (
    <>
      <PageHeader>
        Status Operação - &nbsp; <strong>Etapa Resumo Separação</strong>
      </PageHeader>
      <div style={{ marginTop: 16 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-9">
              <h2>{tp_name}</h2>
            </div>
            <div className="p-col-3">
              <PontuacaoCard pontuacaoTotal={pontuacao_total} pontuacaoObtida={pontuacao_obtida} />
            </div>
            <div className="p-col-12">
              <ResumoInfo
                resumoInfo={resumo_info}
                qtePickingCriados={getQtePickingCriados()}
                qteResumoAtrasado={getQteResumoAtrasado()}
                qteResumoNaoEmitido={getQteResumoNaoEmitido()}
              />
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

function ResumoInfo({ qtePickingCriados, qteResumoNaoEmitido, qteResumoAtrasado, resumoInfo }) {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <PageHeader>Resumo de Separação - Atrasados</PageHeader>
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={azul}
          value={qtePickingCriados}
          title={'Qte Pickings Criados'}
          subTitle={'Qte Pickings Criados no período selecionado'}
        />
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={error}
          value={qteResumoNaoEmitido}
          title={'Qte Resumos Não Emitidos'}
          subTitle={'Resumos de Separação aguardando emissão'}
        />
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={laranja}
          value={qteResumoAtrasado}
          title={'Qte Resumos Atrasados'}
          subTitle={'Resumos de Separação emitidos depois de 2 dias'}
        />
      </div>
      <div className="p-col-12">
        <DataTable value={resumoInfo} emptyMessage={'Nenhum registro encontrado'}>
          <Column field={'empresa'} header={'Empresa'} />
          <Column
            field={'qte_picking_criados'}
            header={'Qte Pick. Concluído'}
            style={{ textAlign: 'center' }}
          />
          <Column
            style={{ overflowWrap: 'break-word' }}
            field={'lista_resumo_nao_emitido'}
            header={'Lista Resumo Não Emitido'}
          />
          <Column
            style={{ overflowWrap: 'break-word' }}
            field={'lista_resumo_atrasados'}
            header={'Lista Resumo Atrasados'}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default withRouter(EtapaResumoSeparacao)
